var React = require('react');

function MenuIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"25","height":"3","rx":"1.5","fill":"black","key":0}),React.createElement("rect",{"y":"6","width":"25","height":"3","rx":"1.5","fill":"black","key":1}),React.createElement("rect",{"y":"12","width":"25","height":"3","rx":"1.5","fill":"black","key":2})]);
}

MenuIcon.defaultProps = {"width":"25","height":"15","viewBox":"0 0 25 15","fill":"none"};

module.exports = MenuIcon;

MenuIcon.default = MenuIcon;
